const RANDOM_CLIENT_ID_LENGTH = 12;

const generateToken = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});

const generateRandomString = (length: number) =>
    new Array(length).join().replace(/(.|$)/g, () =>
        ((Math.random() * 36) | 0).toString(36)[Math.random() < .5 ? 'toString' : 'toUpperCase']());

const generateClientId = () => generateRandomString(RANDOM_CLIENT_ID_LENGTH);

export const generateUtils = {
    generateToken,
    generateClientId
};
